export default () => {
    Array.from(document.querySelectorAll('.property-types')).forEach((propertyTypes) => {
       // console.log('.property-types', this);
    const allPropertyTypesInput = propertyTypes.querySelector('[value="All"]');
    const propertyTypesLabel = propertyTypes.querySelector('label');

    const selectedPropertyTypes = () => (
      propertyTypes.querySelectorAll('[name^="PropertyTypes"]:checked')
    );

    const resetFilters = () => {
      Array.from(propertyTypes.querySelectorAll('[name^="PropertyTypes"]')).forEach((input) => {
        input.checked = (input === allPropertyTypesInput); // eslint-disable-line no-param-reassign
      });
    };

    const updateLabelText = () => {
      if (allPropertyTypesInput.checked) {
        propertyTypesLabel.innerText = 'All property types';
      }
      else {
        const selectedTypes = selectedPropertyTypes();
        if (selectedTypes.length === 1) {
          propertyTypesLabel.innerText = $(selectedTypes[0]).nextAll('label').text();
        }
        else {
          propertyTypesLabel.innerText = `${selectedTypes.length} options selected`;
        }
      }
    };

    Array.from(propertyTypes.querySelectorAll('[name^="PropertyTypes"]')).forEach((input) => {
      const $input = $(input);
      // Prevent the double-firing bug as the label and input respond to the same click
      $input.parent().on('click', (e) => {
        e.stopPropagation();
      });
      $input.on('change', () => {
          console.log("change: product types");
        if (input === allPropertyTypesInput || selectedPropertyTypes().length === 0) {
          resetFilters();
        }
        else {
          allPropertyTypesInput.checked = false;
        }
        updateLabelText();
      });
    });
  });
};
